import React from 'react';

const FeedbackPopup = ({message}) => {
    return (
        <>
            <div className="welcomePopup">
                <div className="popupBox text-center">
                    <h3 className="popup-title">
                        <span>Thank you</span> <br /> {message}
                    </h3>
                </div>
            </div>
        </>
    );
};

export default FeedbackPopup;